import { createFileRoute, createLink, Outlet } from "@tanstack/react-router";
import { Button } from "@heroui/react";
import { CircleUserRound, LogIn } from "lucide-react";
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";

import { authClient } from "@/shared/auth";

const Link = createLink(Button);

export const Route = createFileRoute("/")({
  component: Page,
});

function Page() {
  const { data, isPending } = authClient.useSession();

  return (
    <>
      <header className="border-b border-divider">
        <div className="container max-w-7xl mx-auto flex items-center py-3 px-4">
          <Link
            className="font-bold text-xl"
            to="/dashboard"
            variant="ghost"
          >
            Sapsano
          </Link>

          <nav className="hidden sm:flex items-center gap-4 flex-1 ml-4">
            {/* nav items can be added here */}
          </nav>

          <div className="flex items-center gap-2 ml-auto">
            {(data || isPending) && (
              <Link
                isDisabled={isPending}
                to="/dashboard"
                variant="ghost"
              >
                <CircleUserRound size={16} />
                Кабинет
              </Link>
            )}

            {!data && !isPending && (
              <Link
                to="/login"
                variant="ghost"
              >
                Войти
                <LogIn size={16} />
              </Link>
            )}
          </div>
        </div>
      </header>

      <div className="container max-w-7xl mx-auto py-4">
        <Outlet />
      </div>

      <TanStackRouterDevtools />
    </>
  );
}
